<h2 mat-dialog-title>
  @if (isEdit) {
    <span i18n>Edit comment</span>
  } @else {
    <span i18n>Add comment</span>
  }
</h2>

<mat-dialog-content class="dialog-content" [formGroup]="form">
  <mat-form-field appearance="outline" class="full">
    <mat-label i18n>Title (shown when folded)</mat-label>
    <input matInput formControlName="title" />
    <mat-hint i18n>Leave empty to show no title.</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label i18n>Comment text</mat-label>
    <textarea matInput formControlName="body" rows="4"></textarea>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label i18n>Type</mat-label>
    <mat-select formControlName="type">
      @for (t of commentTypes; track t) {
        <mat-option [value]="t">
          <mat-icon>{{ commentTypeIcons[t] }}</mat-icon>
          {{ t }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="checks">
    <mat-checkbox formControlName="canFold" i18n>Can fold</mat-checkbox>
    <mat-checkbox formControlName="defaultOpen" i18n
      >Open by default</mat-checkbox
    >
    <mat-checkbox formControlName="showIcon" i18n
      >Show icon before title</mat-checkbox
    >
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (isEdit) {
    <button
      matButton="outlined"
      color="warn"
      type="button"
      (click)="deleteComment()"
      i18n
    >
      Delete comment
    </button>
  }
  <span class="spacer"></span>
  <button mat-button type="button" (click)="cancel()" i18n>Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="save()"
    [disabled]="!canSave"
    i18n
  >
    Save comment
  </button>
</mat-dialog-actions>
